import { IIncidentDetails } from '../Incidents/IIncidentTypes'

export enum SearchType {
  VEHICLE_REGISTRATION = 'LicencePlate',
  STORE_NAME = 'StoreName'
}

export interface ISearchOption {
  label: string
  value: SearchType
}

export interface ISearchParams {
  searchType: SearchType
  searchString: string
}

export interface ISearchState {
  isSearching: boolean
  hasSearched: boolean
  searchType: SearchType
  searchString: string
  showNoResults: boolean
  searchError: string
}

// Re-export from existing types since search results use the same structure
export type {
  IIncidentsData,
  IIncidentDetails
} from '../Incidents/IIncidentTypes'

// Search results - direct array without pagination
export interface IIncidentSearchData {
  results: IIncidentDetails[]
}

// Toggle types
export type {
  SearchToggleType,
  IToggleButton,
  ISearchToggleState
} from './SearchToggleTypes'

export {
  UNPAID,
  CIVIL_RECOVERY,
  DRIVE_OFF,
  GONE_TO_CIVIL_RECOVERY
} from './SearchToggleTypes'
